import PropTypes from 'prop-types'
import { XIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import PhoneContainer from './PhoneContainer'
import { ImageSection } from './ImageSection'
import { BasicInfoSection } from './BasicInfoSection'
import { HeaderInfoSection } from './HeaderInfoSection'
import { OverviewSection } from './OverviewSection'
import { AttachmentsSection } from './AttachmentsSection'
import { TicketsSection } from './TicketsSection'

const MobilePreview = ({ formState, eventType }) => {
  const { t } = useTranslation(['eventManagement'])
  const ticketsToShow = formState?.tickets?.filter((ticket) => !ticket.inactive) || []
  const advancedTicketingEnabled = formState.building?.eventTicketsAvailable ?? false

  return (
    <>
      <PhoneContainer>
        <div className="mobile-preview__header">
          <XIcon size={20} />
          <span>{t('eventManagement:common.eventDetails')}</span>
        </div>

        <ImageSection image={formState.image} eventType={eventType} />
        <div className="mobile-preview__info">
          <HeaderInfoSection
            name={formState.name}
            timeStart={formState.timeStart}
            timeEnd={formState.timeEnd}
          />
          <BasicInfoSection
            eventType={eventType}
            organizer={formState.organizer?.text}
            place={formState.place}
            hideAttendees={formState.hideAttendees}
            price={formState.tickets?.[0].price}
            advancedTicketingEnabled={advancedTicketingEnabled}
          />
          <OverviewSection description={formState.description} />
          <AttachmentsSection attachments={formState.files} />
          <TicketsSection
            tickets={ticketsToShow}
            advancedTicketingEnabled={advancedTicketingEnabled}
          />
        </div>
        <div className="mobile-preview__footer">
          <button disabled={ticketsToShow.length === 0}>
            {t('eventManagement:common.signUp')}
          </button>
        </div>
      </PhoneContainer>
    </>
  )
}

MobilePreview.propTypes = {
  formState: PropTypes.object,
  eventType: PropTypes.string,
}

export default MobilePreview
